module.exports = __webpack_public_path__ + "img/placeholder.211d7e54.png";